import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BlogPage from "../pages/blog/page";
import BlogDetail from "../pages/blog/BlogDetail";
import RobotsTxt from "../pages/RobotsTxt";
import SitemapXml from "../pages/SitemapXml";
import BusinessCard from "../pages/businesscard/page";
import BrosurPage from "../pages/brosur/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/blog/:slug",
    element: <BlogDetail />,
  },
  {
    path: "/brosur",
    element: <BrosurPage />,
  },
  {
    path: "/kartvizit",
    element: <BusinessCard />,
  },
  {
    path: "/robots.txt",
    element: <RobotsTxt />,
  },
  {
    path: "/sitemap.xml",
    element: <SitemapXml />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
